import React, { Component } from 'react'

export default class Notfound extends Component {
  render() {
    return (
      <div>
        <h2>Not Found!</h2>
      </div>
    )
  }
}
